import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { Button } from '@airia/ui';
import { getAddinPowerPointChatDeployment } from '../../services/agent';
import { getRequiredConfig } from '../../lib/service-discovery';
import { useUserId } from '../../lib/useUserId';
import { PowerPointAdapter } from '../../lib/host-adapters/powerpoint-adapter';
import { AddinChat } from '../chat/AddinChat';
// Singleton adapter instance
const powerPointAdapter = new PowerPointAdapter();
export function PowerPointMain() {
    const { user } = useAuth();
    const { userId } = useUserId();
    const [agentId, setAgentId] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState();
    useEffect(() => {
        if (!user?.access_token)
            return;
        getAddinPowerPointChatDeployment(user.access_token)
            .then((deployment) => {
            setAgentId(deployment.pipelineId);
            setIsLoading(false);
        })
            .catch((err) => {
            console.error('[PowerPointMain] Failed to get deployment:', err);
            setError('Failed to initialize chat service. Please ensure an AddinPowerPointChat deployment is configured.');
            setIsLoading(false);
        });
    }, [user?.access_token]);
    if (isLoading) {
        return (_jsx("div", { className: "h-full flex flex-col items-center justify-center bg-background", children: _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "animate-spin rounded-full h-8 w-8 border-b-2 border-border mx-auto mb-4" }), _jsx("p", { className: "text-sm text-foreground", children: "Loading..." })] }) }));
    }
    if (error) {
        return (_jsx("div", { className: "h-full flex flex-col items-center justify-center bg-background", children: _jsxs("div", { className: "text-center p-4", children: [_jsx("p", { className: "text-destructive mb-4", children: error }), _jsx(Button, { onClick: () => window.location.reload(), children: "Retry" })] }) }));
    }
    if (!agentId || !user?.access_token) {
        return (_jsx("div", { className: "h-full flex flex-col items-center justify-center bg-background", children: _jsx("div", { className: "text-center p-4", children: _jsx("p", { className: "text-foreground", children: "No chat service available" }) }) }));
    }
    const config = getRequiredConfig();
    return (_jsx(AddinChat, { agentId: agentId, bearerToken: user.access_token, apiUrl: config.apiUrl, userId: userId ?? undefined, hostAdapter: powerPointAdapter, greeting: "Hello! I'm here to help you with your PowerPoint presentation. What would you like to know?" }));
}
